export function setContracts(state, payload) {
  state.contracts = payload;
}
export function setContractReimbursements(state, payload) {
  state.contractReimbursements = payload;
}
export function setOriginalContracts(state, payload) {
  state.originalContracts = payload;
}

export function updateContractCards(state, payload) {
  state.contracts = state.contracts.updateCards(payload);
}

export function updateNewlyInsuredPersons(state, payload) {
  state.contracts = state.contracts.updateNewlyInsuredPersons(payload);
}

export function setContractsForNewlyInsured(state, payload) {
  state.requestedContractsAreForNewlyInsuredPersons = payload;
}

export function updateCardSelectionStatus(state, payload) {
  const { typeOfProduct, customerNumber, card } = payload;

  state.contracts = state.contracts.updateCardSelectionStatus(typeOfProduct, customerNumber, card);
}

export function updateBeforeChangeContracts(state, payload) {
  state.beforeChangeContracts = payload;
}

export function resolvePackageSelectionConflict(state) {
  state.contracts = state.contracts.resolvePackageSelectionConflict();
}

export function updateChosenMedicalSelectionCard(state, payload) {
  const { customerNumber, productComponentCode } = payload;

  state.contracts = state.contracts.updateChosenMedicalSelectionCard(customerNumber, productComponentCode);
}

export function updatePaymentTerm(state, paymentTerm) {
  state.contracts = state.contracts.updatePaymentTerm(paymentTerm);
}

export function setResponseData(state, payload) {
  state.responseData = payload;
}

export function setMedicalSelectionResponse(state, payload) {
  state.medicalSelectionResponse = payload;
}

export function clearContracts(state) {
  state.contracts = undefined;
}
export function setIsLoadingContracts(state, payload) {
  state.isLoadingContracts = payload;
}
export function setIsLoadingContractReimbursements(state, payload) {
  state.isLoadingContractReimbursements = payload;
}

export function setIsLoadingValidateContract(state, payload) {
  state.isLoadingValidateContract = payload;
}

export function setIsSavingContractsSuccesfull(state, payload) {
  state.isSavingContractsSuccesfull = payload;
}
export function setIsSavingContracts(state, payload) {
  state.isSavingContracts = payload;
}
export function setUnselectedRequiredPackages(state, payload) {
  state.unselectedRequiredPackages = payload;
}
export function setShowUnselectedRequiredPackages(state, payload) {
  state.showUnselectedRequiredPackages = payload;
}
